import type { LegacyRef } from 'react';
import { forwardRef } from 'react';
import type { NavProps } from './NavComponent';
import NavComponent from './NavComponent';

export type HorizontalNavProps = NavProps;

function HorizontalNavComponent(
  { children, ...props }: HorizontalNavProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <NavComponent
      ref={ref}
      {...props}
      className={`horizontal-nav ${props.className || ''}`}
    >
      {children}
    </NavComponent>
  );
}

export default forwardRef(HorizontalNavComponent);
